module.exports = __webpack_public_path__ + "static/protupozarno-brtvljenje-21a6903cdef6d6e47e3f90e79ac79f8f.jpg";